import ubiznews from './axios-helper';

function deleteDataApi(url, optsHeader = {}, params) {
  return ubiznews.delete(url, {
    headers: {
      ...optsHeader
    },
    params
  });
}

function putDataApi(url, data = {}, optsHeader = {}) {
  return ubiznews.put(url, data, {
    headers: {
      ...optsHeader
    }
  })
}

function patchDataApi(url, data = {}, optsHeader = {}) {
  return ubiznews.patch(url, data, {
    headers: {
      ...optsHeader
    }
  });
}

const postDataApi = (url, data = {}, optsHeader = {}) => {
  return ubiznews.post(url, data, {
    headers: {
      ...optsHeader
    }
  });
};

function getDataApi(url, optsHeader = {}, params) {
  // eslint-disable-next-line no-console
  return ubiznews.get(url, {
    headers: {
      ...optsHeader
    },
    params
  });
}

export { getDataApi, putDataApi, patchDataApi, postDataApi, deleteDataApi };
